import React from 'react';
import ItemVariation from './ItemVariation';

const ItemVariations = ({ variations, precision }) => {
  const isSingleVariation = variations.length === 1;
  const variationsStyle = {
    display: 'flex',
    flexWrap: 'wrap',
  };

  return (
    <div style={variationsStyle}>
      {variations.map(({ name, price }, index) => (
        <ItemVariation
          key={name}
          name={name}
          price={price}
          isOnlyVariation={isSingleVariation}
          isLastVariation={index === variations.length - 1}
          precision={precision}
        />
      ))}
    </div>
  );
};

export default ItemVariations;
